<script setup>
import { computed } from 'vue';
import { MESSAGE_INSIGHT_STATES } from './intelligence.js';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  body: {
    type: String,
    default: '',
  },
  state: {
    type: String,
    default: MESSAGE_INSIGHT_STATES.EMPTY,
  },
  loadingLabel: {
    type: String,
    required: true,
  },
  errorLabel: {
    type: String,
    required: true,
  },
});

const stateCopy = computed(() => {
  if (props.body) return props.body;
  if (props.state === MESSAGE_INSIGHT_STATES.LOADING) return props.loadingLabel;
  if (props.state === MESSAGE_INSIGHT_STATES.ERROR) return props.errorLabel;

  return '';
});

const stateIcon = computed(() => {
  const map = {
    [MESSAGE_INSIGHT_STATES.READY]: 'i-lucide-text-search',
    [MESSAGE_INSIGHT_STATES.LOADING]: 'i-lucide-loader-2 animate-spin',
    [MESSAGE_INSIGHT_STATES.ERROR]: 'i-lucide-circle-alert',
  };

  return map[props.state] || 'i-lucide-text-search';
});

const stateClass = computed(() => {
  const map = {
    [MESSAGE_INSIGHT_STATES.READY]: 'text-lais-primary',
    [MESSAGE_INSIGHT_STATES.LOADING]: 'text-lais-text-muted',
    [MESSAGE_INSIGHT_STATES.ERROR]: 'text-lais-danger',
  };

  return map[props.state] || 'text-lais-primary';
});
</script>

<template>
  <div class="contents">
    <div
      v-if="stateCopy"
      class="w-full max-w-[34rem] rounded-lais-sm border border-lais-border bg-lais-bg-soft px-3 py-2 text-left"
      data-message-insight-panel
    >
      <div class="flex items-center gap-2">
        <span :class="[stateIcon, stateClass]" class="size-3.5 shrink-0" />
        <p class="text-[11px] font-semibold uppercase text-lais-text-muted">
          {{ title }}
        </p>
      </div>
      <p
        class="mt-1 whitespace-pre-wrap break-words text-xs leading-5 text-lais-text"
      >
        {{ stateCopy }}
      </p>
    </div>
  </div>
</template>
